module.exports = __webpack_public_path__ + "static/edu-f23cb5b55248ca17f940ccff2ca08038.png";